var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"date-filter"},[_c('datepicker',{staticClass:"vs-input input-date-sm",attrs:{"format":_vm.customFormatter},on:{"closed":_vm.setFrom},model:{value:(_vm.from),callback:function ($$v) {_vm.from=$$v},expression:"from"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }